import { GridModel } from "./models"

export type OrderStatus = 'primary' | 'secondary' | 'info' | 'warning' | 'danger' | 'success'

/* CUSTOMERS */

export interface ICustomerInfo extends GridModel {
  name: string
  type: CustomerType
}

export enum CustomerType {
  none = 0,
  web = 1,
  telegram = 2
}

export interface ICustomerGridModel extends ICustomerInfo {
  paymentsCount: number
  paymentsSum: number
  min: number
  max: number
  firstDate: Date
}

export interface ICustomerModel extends ICustomerInfo {
  firstPaymentDate: Date
  lastPaymentDate: Date
  paymentsCount: number
  sum: number
  max: number
  paymentCategory: CustomerPaymentCategory
}

export enum CustomerPaymentCategory
{
    random = 0,
    medium = 1,
    constant = 2,
    premium = 3
}

/* PAYMENTS */

export interface IPayment {
  id: string
  payKeeperId: string
  date: Date
  customer?: ICustomerInfo
  sum: number
  text: string
  typeId?: string
  orderId?: string
  orderDate?: Date
  completeDate?: Date
  onQualificationDate?: Date
  status?: OrderStatus
}

export interface IUser extends GridModel {
  name: string
  email: string
  org: IOrganization
  //для сортировки
  orgName?: string
  roles: RoleType[] 
}

export const initIUser: IUser = {
  id: '',
  name: '',
  email: '',
  org: {
    id: '',
    name: '',
    description: '',
    systemName: '',
    hartiya: false,
    orders: false,
    payments: false
  },
  roles: []
}

/* USERS */

export interface IUserAdd extends IUser {
  password: string
  confirmPassword: string
}

export const initUserAdd = (orgId: string): IUserAdd => {
  return {
    id: '',
    name: '',
    email: '',
    password: '',
    confirmPassword: '',
    org: {
      id: orgId,
      name: '',
      description: '',
      systemName: '',
      hartiya: false,
      orders: false,
      payments: false
    },
    roles: []
  }
}

export type RoleType = "Orders" | "Payments" | "Moderator" | "Admin" | "Hartiya" | "Stats"

export interface IOrgAdd {
  name: string
  description?: string
  systemName: string
  site?: string
  telegramAccount?: string 
}

export const initOrgAdd: IOrgAdd = {
  name: '',
  description: '',
  systemName: ''
}

export interface IOrgInfo extends GridModel, IOrgAdd {
}

export interface IOrgFeatures {
  hartiya: boolean
  orders: boolean
  payments: boolean
}

export interface IOrganization extends IOrgInfo, IOrgFeatures {
}

export interface IHartiyaOrder extends GridModel {
  authorId: string
  author: string
  sentDate: Date
  orderDate: Date
  orderNameDate: number
}